module.exports = __webpack_public_path__ + "static/media/cbse.760b448a.png";